import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/scenario-evaluation-template-preview-action-types';
import {sanitizeQuestions} from '../helpers/evaluation-helpers';

import type {List, Map} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type ScenarioEvaluationTemplatePreviewStore = {
    evaluationTemplate?: Map<unknown, unknown>;
    questions: List<unknown>;
};

const initialState = (): ScenarioEvaluationTemplatePreviewStore => {
    return {
        evaluationTemplate: Immutable.Map(),
        questions: Immutable.List(),
    };
};

const actionsMap: ActionsMap<ScenarioEvaluationTemplatePreviewStore> = {
    [actionTypes.GET_QUESTIONS_SUCCESS]: (state, action) => {
        return {
            questions: sanitizeQuestions(action.data),
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<ScenarioEvaluationTemplatePreviewStore>(initialState(), actionsMap);
